import { useEffect, useMemo, useRef } from 'react'

export default function IdleLogout({ isImpersonating, onLogout, onLogoutImpersonate }) {
  const timer = useRef(null)
  const bc = useRef(null)

  const logout = isImpersonating ? onLogoutImpersonate : onLogout
  const normalMs = useMemo(() => {
    const prodOrigin = 'https://core.quikipay.com'
    const isProd = window.location.origin === prodOrigin
    return isProd ? 3 * 60 * 1000 : 30 * 60 * 1000
  }, [])

  useEffect(() => {
    const reset = () => {
      clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        bc.current?.postMessage({ type: 'FORCE_LOGOUT' })
        try {
          logout?.()
        } finally {
          localStorage.clear()
          sessionStorage.clear()
          window.location.reload()
        }
      }, normalMs)
    }

    bc.current = new BroadcastChannel('auth')
    bc.current.onmessage = e => {
      if (e?.data?.type === 'FORCE_LOGOUT') {
        try {
          logout?.()
        } finally {
          localStorage.clear()
          sessionStorage.clear()
          window.location.reload()
        }
      }
      if (e?.data?.type === 'USER_ACTIVITY') {
        reset()
      }
    }

    const handleActivity = () => {
      reset()
      bc.current?.postMessage({ type: 'USER_ACTIVITY' })
    }

    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart']
    events.forEach(ev => window.addEventListener(ev, handleActivity, { passive: true }))
    const onVisibility = () => document.visibilityState === 'visible' && handleActivity()
    document.addEventListener('visibilitychange', onVisibility)

    reset()

    return () => {
      events.forEach(ev => window.removeEventListener(ev, handleActivity))
      document.removeEventListener('visibilitychange', onVisibility)
      clearTimeout(timer.current)
      bc.current?.close()
    }
  }, [normalMs, logout])

  return null
}
